import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'chatmodal',
    styleUrls: ['./chatmodal.component.scss'],
    templateUrl: './chatmodal.component.html'
})
export class ChatModalComponent {
    @Input() chatModalProps: any = {};
    @Output() onBtnSelection = new EventEmitter<boolean>();

    modalHandler(btnOutput: boolean) {
        this.onBtnSelection.emit(btnOutput);
        this.chatModalProps.state = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/common/chatmodal/chatmodal.component.ts